import { API } from "aws-amplify";

const showSensorAll = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/all", myInit);
    return items;
};
const showSensorData = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/sensor-data", myInit);
    return items;
};
const showSensorDataLatest = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/sensor-data-latest", myInit);
    return items;
};
const showSensorDataHistories = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params, // OPTIONAL
        headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/sensor-data-histories", myInit);
    return items;
};

const index = async (params) => {
    let myInit = { // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: params, // OPTIONAL
      headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor", myInit);
    return items;
};
  
const insert = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
          data: params
        },
        headers: {} // OPTIONAL
    };
  
    let res = await API.post("InasakuAPI", "/api/sensor", myInit);
  
    return res;
};

const update = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
          data: params
        },
        headers: {} // OPTIONAL
    };
  
    let res = await API.put("InasakuAPI", "/api/sensor", myInit);
  
    return res;
};

const del = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
          data: params
        },
        headers: {} // OPTIONAL
    };
  
    let res = await API.del("InasakuAPI", "/api/sensor", myInit);
  
    return res;
};

const pagingAlert = async (params) => {
    let myInit = { // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: params, // OPTIONAL
      headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/alert", myInit);
    return items;
};

const historyRawdata = async (params) => {
    let myInit = { // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: params, // OPTIONAL
      headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/raw", myInit);
    return items;
};

const historyRawdataAll = async (params) => {
    let myInit = { // OPTIONAL
      response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
      queryStringParameters: params, // OPTIONAL
      headers: {}
    };
    let items = await API.get("InasakuAPI", "/api/sensor/histories", myInit);
    return items;
};

export default {
    showSensorAll,
    showSensorData,
    showSensorDataLatest,
    showSensorDataHistories,
    index,
    insert,
    update,
    del,
    pagingAlert,
    historyRawdata,
    historyRawdataAll
};